import { render, staticRenderFns } from "./Kardex.vue?vue&type=template&id=5f8eaa9d&scoped=true"
import script from "./Kardex.vue?vue&type=script&lang=js"
export * from "./Kardex.vue?vue&type=script&lang=js"
import style0 from "./Kardex.vue?vue&type=style&index=0&id=5f8eaa9d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8eaa9d",
  null
  
)

export default component.exports